import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconNotepad: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"notepad,notes"} maskId="square-filled-radius-0-stroke-1-IconNotepad"><path fillRule="evenodd" clipRule="evenodd" d="M8 1.75V2.55556H11.5V1.75H12.5V2.55556H16V1.75H17V2.55556H20.5V21.5H3.5V2.55556H7V1.75H8ZM8 9H16V10H8V9ZM8 13H14V14H8V13Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconNotepad;
